import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.JUEGA_Y_CONJUGA;

export const GAME_WIDTH = 1024;
export const GAME_HEIGHT = 576;

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD: 'STANDARD',
  ONBOARDING: 'ONBOARDING',
  INSTRUCTION: 'INSTRUCTION',
  SENTENCE: 'SENTENCE',
  WHEEL_PAYOFF: 'WHEEL_PAYOFF',
  PAYOFF: 'PAYOFF',
  LOADING: 'LOADING',
};

export const REDUX_ACTIONS = {
  START_LEVEL: 'START_LEVEL',
  MARK_PRONOUN_LEVELS_AS_SEEN: 'MARK_PRONOUN_LEVELS_AS_SEEN',
  INCREMENT_PROGRESS: 'INCREMENT_PROGRESS',
  COMPLETE_ONBOARDING: 'COMPLETE_ONBOARDING',
  ADD_DISABLED_WORDS_ID: 'ADD_DISABLED_WORDS_ID',
  ADD_TO_COMPLETED_WORDS: 'ADD_TO_COMPLETED_WORDS',
  CLEAR_DISABLED_WORDS_ID: 'CLEAR_DISABLED_WORDS_ID',
  SET_LAST_SELECTED_WORDS: 'SET_LAST_SELECTED_WORDS',
  INCREMENT_CORRECT_ITEMS_COUNT: 'INCREMENT_CORRECT_ITEMS_COUNT',
  INCREMENT_CORRECT_STANDARD_ITEMS_COUNT: 'INCREMENT_CORRECT_STANDARD_ITEMS_COUNT',
  INCREMENT_CORRECT_SENTENCE_ITEMS_COUNT: 'INCREMENT_CORRECT_SENTENCE_ITEMS_COUNT',
};

export const ANIMAL_TYPES = {
  BIRD: 'BIRD',
  FLAMINGO: 'FLAMINGO',
  GIRAFFE: 'GIRAFFE',
  LION: 'LION',
  MONKEY: 'MONKEY',
  PANDA: 'PANDA',
  UNICORN: 'UNICORN',
};

export const INSTRUCTION_TYPES = {};

export const WHEEL_SECTION_COLORS = [
  '#ff595e',
  '#ffca3a',
  '#8ac926',
  '#1982c4',
  '#6a4c93',
];

export const IN_BETWEEN_BRACKETS_RGX = /\[(.*)\]/;

export const IN_BETWEEN_ASTERIKS_RGX = /\*(.*?)\*/;

export const IN_BETWEEN_ASTERIKS_AND_BRACKETS_RGX = /[[*](.*?)[\]*]/g;

export const BUTTON_TYPES = {
  RAISED: 'raised',
  CUSTOM_RAISED_ICON: 'custom_raised_icon',
  RAISED_ICON: 'raised_icon',
  LOW_PROFILE: 'low_profile',
};

export const MAX_ITEM_ATTEMPTS = 2;

// Wheel constants
export const DIAMETER = 430;
export const FASTENING_SIZE = 20;
export const OUTER_BORDER_HALF_WEIGHT = 10;
export const WHEEL_RADIUS = DIAMETER / 2 - OUTER_BORDER_HALF_WEIGHT;
export const WHEEL_SPIN_DURATION = 1;

export const COLORS_SCHEMES = {
  PRONOUN: {
    roof: '#D75004',
    main: '#229943',
    shadow: '#106B29',
    wheel: '#5EBE79',
    stand: '#9AD5AA',
    activeMain: 'white',
  },
  VERB: {
    roof: '#D75004',
    main: '#214ED0',
    shadow: '#052EA3',
    wheel: '#4893FF',
    stand: '#A4C4F7',
    activeMain: 'white',
  },
};

export const LEVEL_TYPES = {
  VERB: 'verb',
  PRONOUN: 'pronoun',
};
